import project from './project';
import admissionRequirementsConfig from  'wwg-utilities/dist/config/admissionRequirementsConfig';

const requirements = admissionRequirementsConfig[project].requirements;
const requirementsIcon = admissionRequirementsConfig[project].requirementsIcon;
export default requirements;
export { requirementsIcon };
